export const messages = {
  en: {
    title: 'NFL',
    notFound: 'Page not found',
  },
}
